'use strict';

class YaMapFilter {
    constructor(e, callback) {
        this._e = document.getElementById(e);
        this._bindFormSubmit(callback);
        this._bindCheckEvent();
    }

    disableFilterData(filter_result) {
        filter_result.forEach(function (placemark) {
            //console.log(placemark.services);

            for (let service in placemark.services) {
                //console.log(service);
                //console.log(placemark.services[service]);
            }
            ;
        });
    }

    _matchFilterResult(service) {
        let checkboxs = $(this._e).find('input[type="checkbox"]');

        for (let i in filters) {
            if (filters[i] === +placemark.services[i]) {
                match_count++;
            }
        }
    }

    _bindFormSubmit(callback = false) {
        $(this._e).on('submit', (e) => {
            e.preventDefault();
            let filter = this._getFilterData();

            if (callback) {
                callback(filter);
            }
        })
        
    }

    _bindCheckEvent() {
        let checkboxs = $(this._e).find('input[type="checkbox"]');

        checkboxs.each((index, checkbox) => {
            $(checkbox).on('change', () => {
                $(this._e).submit();
            });
        })
        
    }

    _getFilterData() {
        let checkboxs = $(this._e).find('input[type="checkbox"][name!=parent_filter]');

        let filter_data = {};

        checkboxs.each((index, checkbox) => {
            if ($(checkbox).prop('checked')) {
                let service = $(checkbox).val();
                filter_data[service] = 1;
            }
        });
        let resultFilters = [];
        let parents = $(this._e).find('input[type="checkbox"][name=parent_filter]');
        let allZero={}
        parents.each((index, parent) => {
            let val = $(parent).val();
            allZero[val]=0;
        });
        parents.each((index, parent) => {
            let val = $(parent).val();
            let enable = $(parent).prop('checked') ? 1 : 0;
            let filter = Object.assign(Object.assign({}, allZero), filter_data)
            filter[val]=enable;
            resultFilters.push(filter);
        });
        
        //filter_data = [{"gtd":1, "5post":1}, {"gtd":0, "5post":1}, {"gtd":1, "5post":0}];
        //console.log(resultFilters)

        return resultFilters;
    }
}

